import { useMemo, type CSSProperties } from "react";
import Shift from "./Shift";
import UnavailableEvent from "../../../../../components/UnavailableEvent";
import OpenShift from "./OpenShift";
import { useScheduleContext } from "../../../../../hooks/context/useScheduleContext";
import { usePreferences } from "../../../../../../../Settings/Configuration/hooks/usePreferences";
import { SCHEDULE_PREFERENCE_KEYS } from "../../../../../constants/scheduleTypes";

interface EventDisplayProps {
    event: any;
    style?: CSSProperties;
    className?: string;
    cellWidth: number;
}

function EventDisplay({ event, style, className, cellWidth }: EventDisplayProps) {
    const { type } = useScheduleContext();
    const unavailableDisplay = usePreferences(`${SCHEDULE_PREFERENCE_KEYS[type]}.unavailableDisplay`) ?? "block";
    const content = useMemo(() => {
        if (unavailableDisplay === "available-hover" && event?.type === "unavailable") {
            return null;
        } else if (event?.type === "unavailable" && unavailableDisplay === "block") {
            return (
                <UnavailableEvent
                    event={event}
                    style={{ ...style, borderRadius: 0 }}
                />
            );
        } else if (event?.type === "open-shifts") {
            return (
                <OpenShift
                    event={event}
                    style={style}
                />
            );
        } else {
            return (
                <Shift
                    event={event}
                    className={className}
                    style={style}
                    cellWidth={cellWidth}
                />
            );
        }
    }, [event, style, className, cellWidth, unavailableDisplay]);

    return content;

};

export default EventDisplay;
